import React from "react";

import internalServerError from "assets/images/internalServerError.svg";
import WarningIcon from "components/Icons/WarningIcon";

import styles from "./ErrorState.module.scss";

const getErrorContent = (statusCode) => {
  if (statusCode >= 500) {
    return {
      title: "Something went wrong",
      message:
        "Something went wrong at our end. Please try again later. You may reach out to our customer support team at 1800-570-6262 for further assistance.",
    };
  }

  return {
    title: "Something went wrong",
    message:
      "Something went wrong at our end. Please try again later. You may reach out to our customer support team at 1800-570-6262 for further assistance.",
  };
};

const ErrorState = ({ statusCode, message }) => {
  const content = getErrorContent(statusCode);

  return (
    <div className={styles.errorMainContainer}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
         {statusCode ? <WarningIcon width={48} height={48} /> : <img src={internalServerError} alt="Internal Server Error" />}
        </div>
        <div className={styles.title}>{content.title}</div>
        <div className={styles.bodyText}>{message || content.message}</div>
      </div>
    </div>
  );
};

export default ErrorState;
